module.exports = __webpack_public_path__ + "static/media/farms.23e3f2f8.png";